module.exports = __webpack_public_path__ + "static/media/SP_C_Timeless_Piazza_DK Grey.7de698ec.png";